import {
  Avatar,
  Box,
  Button,
  Typography
} from '@mui/material';

import { DeleteOutline } from '@mui/icons-material';
import { FileUploadField } from 'modules/common/layer00';



export type PhotoUploadFieldProps = {
  file: FileUploadField.IFile | null;

  onClickDelete: () => void;
  onChange: (file: FileUploadField.IFile) => void;
};

export const FC = (props: PhotoUploadFieldProps) => {
  return (
    <FileUploadField.FC
      onUploadedFile={(file) => props.onChange(file)}
    >
      {(handleClick) => (
        <Box
          sx={{
            border: '1px solid #D9DDDB',
            borderRadius: '8px',
            display: 'flex'
          }}
        >
          <Box sx={{
            padding: 1,
            borderRight: '1px solid #EBEDEC'
          }}
          >
            {props.file
              ? (
                <Box
                  component='img'
                  src={props.file.dataUrl}
                  sx={{
                    width: '72px',
                    height: '72px',
                    borderRadius: '4px'
                  }}
                />
              )
              : (
                <Box sx={{
                  width: '72px',
                  height: '72px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                >
                  <Avatar />
                </Box>
              )}
          </Box>

          <Box sx={{
            flex: 1,
            display: 'flex',
            columnGap: 6,
            alignItems: 'center',
            px: 5
          }}
          >
            <Box sx={{
              flex: 1,
              textAlign: 'right',
              color: '#67726D'
            }}
            >
              {props.file
                ? (
                  <>
                    <Typography>{`${props.file?.fileType} ${100}x${100}px`}</Typography>
                    <Typography>{(props.file.sizeBytes / 1024).toFixed(0)}kb</Typography>
                  </>
                )
                : (
                  <Button onClick={handleClick}>Set Profile Picture</Button>
                )}
            </Box>

            {props.file && (
              <Button
                startIcon={<DeleteOutline />}
                sx={{
                  color: '#474E4B'
                }}
                onClick={props.onClickDelete}
              >
                Delete
              </Button>
            )}
          </Box>
        </Box>
      )}
    </FileUploadField.FC>
  );
};
